<script setup lang="ts">
  import type { ILogo } from '@/components/main-header/types'

  const { locale } = useI18n()

  const props = withDefaults(
    defineProps<{
      logo: ILogo
      provider?: string
    }>(),
    {
      provider: 'storyblok'
    }
  )

  const backgroundColor = computed(() => {
    const defaultBgColor = 'bg-bt-green'
    const bgColorMapping: { [key: string]: string } = {
      white: 'white',
      'green-base': defaultBgColor,
      'blue-dark': 'bg-bt-blue-dark'
    }

    return bgColorMapping[props.logo.background] ?? defaultBgColor
  })
</script>

<template>
  <NuxtLink
    :to="{ name: `index___${locale}` }"
    :title="logo.icon.alt"
    class="flex h-14 w-24 items-center justify-center md:h-20 md:w-40"
    :class="backgroundColor"
    external
  >
    <NuxtImg
      v-if="logo.icon.source"
      :provider="provider"
      :src="logo.icon.source"
      :alt="logo.icon.alt"
      width="112"
      height="32"
      class="h-8 w-16 md:h-18 md:w-28"
      loading="eager"
    />
  </NuxtLink>
</template>
